import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-16 text-center small-label">Authenticating…</div>;
  if (!user || user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <div className="p-16 text-center small-label text-danger">Access denied — {user.role} cannot view this area.</div>;
  return children;
}
